<!-- The <mat-spinner> component is an alias for <mat-progress-spinner mode="indeterminate"> -->
<mat-spinner class="custom-spinner" [diameter]="diameter" color="accent"></mat-spinner>
